/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * 0 = None
 * 1 = Lightblue
 */
export enum RowBackgroundColours {
    '_0' = 0,
    '_1' = 1,
}
